import 'jquery';
import * as angular from 'angular';
import { CtrlDocumentInfo } from './documentinfo/CtrlDocumentInfo';
import * as Admin from './admin/KWFApplication.Admin';
import { fn, IInfOperation, FixupRelPath } from '@common/utils';
import { KWFApplicationService } from './KWFApplication';
import { IDialogState, IDialogRoute, DialogService } from '@services/dialogservice';
import { INavCustomization, NavSettingsService } from '@common/services/settingsservice';
import { KWFBenutzerSchreibtisch } from './userdesk/userdesk';
import UISafe = fn.UISafe;
import { CtrlStartPage, ITileSettings, LinkIcon, Tile } from './infotiles/infotiles.ctrl';
import { CheckVersionController } from './checkversion/checkversion.ctrl';
import { ViewAdminController } from './admin/viewadmin.ctrl';
import { KWFJobQueueController } from './admin/jobqueue.ctrl';
import { CtrlKWFEdit } from './editform/editform.ctrl';
import { RwfAutoResolver, IRwfSettings, RwfBootstrap } from '@common/rwf';
import { IRwfApplicationSettings } from '@common/rwf/rwf.appsettings';
import { CtrlPurchOrder } from './editform/pageitemview/purchorder.ctrl';
import { CtrlWizardItem } from './editform/pageitemview/wizarditem.ctrl';
import { CtrlRwfDocument } from './rwfdocument/rwfdocument.ctrl';
import { CtrlChangeCompany } from './rwfroot/changecompany.ctrl';
import { CtrlCustomMenuAdmin } from './rwfroot/custommenu/custommenu.ctrl';
import { CtrlTestSignature } from './infoma.sign';
import { SPAProxyImp } from './rwf.spa.proxy';
import { RWFPreviewController } from './rwfpreview/rwfpreviewcontroller';

//#region Custom Interfaces/Extensions

/** Root scope for KWF Application */
export interface IKWFRootScope extends ng.IScope {

    /** Title = Name of Current Route */
    CurrentTitle: string;

    /** Calculated by "DescriptionFormula" of current Route applied to Current scope */
    CurrentDescription: string;

    ApplicationTitle: string;

    ApplicationProduct: string;

    /** To Display UserInfo etc. on title */
    KWFSettings: IRwfSettings;

    /** Access to JSON Based App Settings (after successfull initialization) */
    KWFApplicationSettings: IRwfApplicationSettings;

    /** Access to static Admin Functionality */
    KWFAdmin?: typeof Admin;

    /** Test Navigations ... */
    Navigations: { name: string; url: string }[];

    /** History of Navigation Urls (ncessary?) */
    NavigationHistory: string[];

    /** Is ChangeCompany Enabled in Current Context (Only on some Views, not in SharepointMode ...)? */
    AllowChangeCompany: boolean;

    /** Server Synced Application State Information */
    ApplicationState: kendo.data.ObservableObject;

    /** Globally Available AppActions */
    AppActions: { [name: string]: IInfOperation };

    ShowBar?: boolean;
}

/** Custom Scope Functionality */
export interface IKWFRoute extends ng.route.IRoute {

    //MSQQQ
    name?: string;
    /**
    * {(string|function()=}
    * Controller fn that should be associated with newly created scope or the name of a registered controller if passed as a string.
    */
    controller?: any;

    /** Custom Formula to calculate 'Name' part of Header of Current Route */
    NameFormula?: string | ((scope: ng.IScope) => string);

    /** Custom Formula to Determine 'Description' part of Header for current Route */
    DescriptionFormula?: string;

    /** Custom Formula to Determine the Title of html for this route */
    TitleFormula?: string;

    /** Hide Root Title Bar */
    HideBar?: boolean;

    /** Allow Change Company on Route? */
    AllowChangeCompany?: boolean;
}

//#endregion

/** Utility / Helper to Show a Defined Route in a modal  Window (for testing etc. ) */
export function ShowRouteModal(route: string | (ng.route.IRoute & Partial<IKWFRoute>), injector?: ng.auto.IInjectorService): PromiseLike<IDialogState> {
    injector = injector || (<ng.auto.IInjectorService>angular.element(window.document).injector());
    var dlg = injector.get<DialogService>("DialogService");

    route = resolveRoute(route, injector);

    var dlgRoute = <IDialogRoute>$.extend({}, route || routeUserDesk);
    if (!dlgRoute.titleFormula && route)
        dlgRoute.titleFormula = route.TitleFormula;
    dlgRoute.windowOptions = { resizable: true, actions: ["maximize", "close"], modal: true };
    return dlg.ShowWindow(<any>dlgRoute);
}

export function ChangeRoute(route: string, injector?: ng.auto.IInjectorService) {
    injector = injector || angular.element(window.document).injector();
    const $location = injector.get("$location"),
        $rootSoppe = injector.get("$rootScope");
    $location.path(route);
    $rootSoppe.$applyAsync();
}

function resolveRoute(route: string | ng.route.IRoute, $injector?: ng.auto.IInjectorService) {
    $injector = $injector || angular.element(window.document).injector();

    const $routeService = $injector.get<ng.route.IRouteService>("$route");

    if (typeof route === "string") {
        var checkRoutes = fn.ToDictionaryEx(calculateRouteInfos($routeService), item => item.originalPath, fn.identity);
        if (!checkRoutes[route])
            throw new Error("Route '" + route + "' not found in  '" + Object.getOwnPropertyNames(checkRoutes).join("','") + "'");
        route = checkRoutes[route];
    }
    return route;
}

/** Utitlity to access a resolve route information */
export interface IWKFRouteAccess extends IKWFRoute {
    originalPath: string;
    keys: any[];
}

/**
*  Calculate Info about Registered ('named')('KWF' - ) Routes
*/
function calculateRouteInfos($routeService: ng.route.IRouteService) {
    return Object.getOwnPropertyNames($routeService.routes).map(item => <IWKFRouteAccess>$routeService.routes[item])
        .filter(route => route.name &&
            route.originalPath &&
            route.name != "/" &&
            route.name !== routeTestPages.name &&
            (!route.keys || route.keys.length == 0) &&
            route.originalPath.lastIndexOf("/") != route.originalPath.length + 1)
        .sort((a, b) => a.name.localeCompare(b.name));
}

//#region Route Configuration

/** Route setup for Application */
var kwfRoutes = ['$routeProvider', '$sceDelegateProvider', '$locationProvider', function kwfRoutes($routeProvider: ng.route.IRouteProvider,
    $sceDelegateProvider: ng.ISCEDelegateProvider, $locationProvider: ng.ILocationProvider) {
    //$locationProvider.html5Mode(true); // Consequences ???
    $locationProvider.hashPrefix('');
    var isBrowserValid = Modernizr.canvas && Modernizr.postmessage && Modernizr.fontface && Modernizr.websocketsbinary && (!$(":root").hasClass("k-ie10")); //kendo.support.browser.msie
    if (!isBrowserValid) {
        $routeProvider.
            when('/errorUnsupportedBrowser', routeErrorUnsupportedBrowser).
            otherwise({ redirectTo: '/errorUnsupportedBrowser' });
    } else {
        $routeProvider.
            when('/kwfEditForm/:id/:ssp', CtrlKWFEdit.Route).
            when('/kwfEditForm/:instanceId', CtrlKWFEdit.Route).
            when('/kwfError', routeError).
            when('/errorUnsupportedBrowser', { redirectTo: '/' }).
            when('/adminConnections', routeAdminConnections).
            when('/adminConnectedClients', routeConnectedClients).
            when('/adminAppSettings', routeAdminAppSettings).
            when('/jobqueueentries', KWFJobQueueController.Route).
            when('/adminViews', routeAdminViews).
            when('/kwfOrderInfo/:orderNo?', routeOrderInfo).
            when('/kwftestPages', routeTestPages).
            when('/userdesk/:view?/:filter?', routeUserDesk).
            when('/userdesk', routeUserDesk).
            when('/version', CheckVersionController.Route).
            when('/custommenuadmin', CtrlCustomMenuAdmin.Route).
            when('/testsignature', CtrlTestSignature.Route).
            when('/docinfo/:id?', routeDocInfo).
            when(`/${CtrlPurchOrder.RouteName}/:id/:extid?`, CtrlPurchOrder.Route).
            when(`/${CtrlWizardItem.RouteName}/:GUID/:extid?`, CtrlWizardItem.Route).
            when(`/${SPAProxyImp.RouteName}/:extid`, SPAProxyImp.Route).
            when(`/${RWFPreviewController.RouteName}/`, RWFPreviewController.Route).
            when('/start', CtrlStartPage.Route).
            when('/', CtrlStartPage.Route).
            otherwise({
                redirectTo: '/kwfError'
            });
    }

    // MSQQQ
    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        'self',
        // Allow loading from our assets domain.  Notice the difference between * and **.
        '**'
    ]);
}];

//#endregion

//#endregion

/** UserDesk route */
var routeUserDesk: IKWFRoute = {
    TitleFormula: "ApplicationTitle",
    DescriptionFormula: "::KWFSettings.CurrentCompany",
    NameFormula: 'ApplicationProduct',
    name: "Rechnungsworkflow",
    reloadOnSearch: false,
    controller: "KWFUserDeskCtrl",
    template: require('./userdesk/userdesk.html'),
    resolve: {
        /** Ensure Resolution of Settings etc. on KWFBenutzerSchreibtisch Intance */
        "KWFBenutzerSchreibtisch": ["KWFBenutzerSchreibtisch",
            (KWFBenutzerSchreibtisch: KWFBenutzerSchreibtisch) => KWFBenutzerSchreibtisch.Resolve]
    },
    AllowChangeCompany: true
};

//#region route Show Test Pages

var routeTestPages: IKWFRoute = {
    TitleFormula: "Title",
    DescriptionFormula: "Detail",
    resolve: {
    },
    template:
        '<h3>Registrierte Ansichten : </h3><br/>' +
        '<div ng-repeat="route in ::TestRoutes track by $index">' +
        '<ul>' +
        '<br />' +
        // MSQQQ '#'
        '<a ng-href="#{{::route.originalPath}}" title="{{::route.controller.toString()}}" ng-mouseenter="$parent.Detail = route.templateUrl || $parent.Title" ng-mouseleave="$parent.Detail = $parent.Title" >{{::route.name}}</a>' +
        '</ul>' +
        '</div>',
    controller: ["$scope", "$rootScope", "$route", function CtrlDefault($scope: ng.IScope, $rootScope: IKWFRootScope, $routeService: ng.route.IRouteService) {
        var routes = $scope["TestRoutes"] = calculateRouteInfos($routeService);
        $scope["Title"] = $scope["Detail"] = routes.length + " Ansichten gefunden";
    }],
    name: "TestSeiten"
};

//#endregion

//#region route OrderInfo

//MSQQQ Obsolete ??? (from KWF2?)
var routeOrderInfo: IKWFRoute = {
    DescriptionFormula: "'Bestellauskunft'",
    TitleFormula: "'Bestellauskunft'",
    controller: "CtrlWKFOrderInformation",
    template: require("./editform/orderinformation/orderinformation.html"),
    resolve: {
        "OrderNo": ["$location", ($location: ng.ILocationService) => $location.search()["orderNo"]],
        "NavUrl": ["$location", ($location: ng.ILocationService) => $location.search()["navUrl"]]
    },
    HideBar: true // As shown in Modal Window (ASP)
};

//#endregion

//#region routeDocInfo

var routeDocInfo: IKWFRoute = {
    DescriptionFormula: "'Belegauskunft' + (WFInstanceCompletedData.EntryNo ?  ' für Workflow Nr. ' + WFInstanceCompletedData.EntryNo : '')",
    name: "Rechnungsworkflow",
    controller: CtrlDocumentInfo,
    template: require("./documentinfo/documentinfo.fragment.html"),
    resolve: {
        "RwfBootstrap": ["RwfBootstrap", (RwfBootstrap: RwfBootstrap) => RwfBootstrap.Resolve.then(() => RwfBootstrap)],
        "WFInstanceCompletedResult": ["Rwf", "$route", ($rwf: RwfAutoResolver, $route: ng.route.IRouteService) => {
            var docid = $route.current.params["id"];
            if (!docid)
                throw new Error("Fehlender Parameter 'id'");

            return CtrlDocumentInfo.GetArchivedDocInfo($rwf, docid);
        }]
    }
};
//#endregion

//#region routeError

/** TODO Error Route */
var routeError: IKWFRoute = {
    DescriptionFormula: "'Fehler'",
    template: `<div>Error! [TODO]</div>`,
    controller: [function () {

    }],
    AllowChangeCompany: true,
};

var routeErrorUnsupportedBrowser: IKWFRoute = {
    DescriptionFormula: "'Fehlermeldung'",
    template: require('./admin/errorUnsupportedBrowser.fragment.html'),
    controller: ["$rootScope", function ($rootScope: IKWFRootScope) {
        $rootScope["ErrorBrowserUnsupported"] = true;
    }],
    AllowChangeCompany: true,
};

//#endregion

const routeAdminConnections = <IKWFRoute>{
    DescriptionFormula: "curr.AppName",
    template: require('./adminconnections/adminConnections.html'),
    controller: "KWFAdminController",
    name: "Administration",
    AllowChangeCompany: true
}, routeConnectedClients = <IKWFRoute>{
    DescriptionFormula: "'Anzahl verbundener Clients: ' + Clients.length",
    template: require('./adminconnections/adminConnectedClients.html'),
    controller: "KWFAdminController",
    name: "Administration",
    AllowChangeCompany: true
}, routeAdminAppSettings: IKWFRoute = {
    TitleFormula: "'Anwendungseinstellungen'",
    DescriptionFormula: "'Anwendungseinstellungen'",
    template: require('./admin/appsettings.html'),
    controller: ["$scope", "AdminAppSettings", ($scope, AdminAppSettings) => { $scope["AdminAppSettings"] = AdminAppSettings; }],
    resolve: {
        "AdminAppSettings": ["KWFApplication", (kwfApp: KWFApplicationService) => UISafe(kwfApp.LoadAdminSettings())]
    },
    name: "Administration",
    AllowChangeCompany: true
};

/** Route for Configuring Admin Views */
var routeAdminViews = <IKWFRoute>{
    DescriptionFormula: "'Ansichten für Konfiguration \"' +  View.CurrentConfig.Config.Description +  '\"'",
    template: ViewAdminController.Template,
    controller: "ViewAdminController",
    name: "Administration",
    resolve: {
        "NavUrl": ["KWFApplication", (KWF: KWFApplicationService) => KWF.GetGlobalSettings().then(s => s.NavUrl)],
        "NavCustomization": ["NavCustomization", "$route", (customization: INavCustomization, route: ng.route.IRouteService) => {
            var explicit = route.current.params && <string>route.current.params["configName"];
            if (explicit)
                return <INavCustomization>{ ConfigName: explicit };
            return customization;
        }]
    },
    AllowChangeCompany: false
};
//#region Module Configurations

/** Problem is : Routing Params can not include '/' */
function navRevertUrl(url) {
    return (url || "").replace(new RegExp("[*]", 'g'), "/");
}

/** Problem is : Routing Params can not include '/' */
function navEncodeUrl(url) {
    var result = url ? encodeURIComponent(url) : "";
    if (result) {
        result = result.
            replace(/%2f/gi, '*').
            replace(/%40/gi, '@').
            replace(/%3A/gi, ':').
            replace(/%24/g, '$').
            replace(/%2C/gi, ',').
            replace(/%26/gi, '&').
            replace(/%3D/gi, '=').
            replace(/%2B/gi, '+')
            ;
    }
    return result;
}

//#endregion

//#endregion

angular.module("KWFApplication", ["ngAnimate", "ngRoute", "KWF.Services", "KWF.EditForm", "KWF.Admin", "BenutzerSchreibtisch", "kendo.directives"])
    .config(kwfRoutes)
    .filter('navEncodeUrl', () => navEncodeUrl)
    .filter('navRevertUrl', () => navRevertUrl)
    .controller("CtrlChangeCompany", CtrlChangeCompany)
    .directive('rwfDocument', CtrlRwfDocument.Directive)
    .controller("CtrlDocumentInfo", CtrlDocumentInfo)
    .directive("linkicon", LinkIcon)
    .directive("tile", Tile)
    .constant("TileSettings", <ITileSettings>{ Thresholds: { Large: 500, Medium: 100, Small: 10 } })
    ;

;
